import type { Transaction } from "@/utils/types";
import { defineStore } from "pinia";

export const useSelectedTransactionStore = defineStore("selectedTransaction", {
  state: () => ({
    selectedTransaction: null as Transaction | null,
    splitTargetTransaction: null as Transaction | null,
    commentsOpen: false,
  }),
  actions: {
    openTransactionDrawer(transaction: Transaction, { comments = false } = {}) {
      this.selectedTransaction = transaction;
      this.commentsOpen = comments;
    },
    closeTransactionDrawer() {
      this.selectedTransaction = null;
      this.commentsOpen = false;
    },
    openSplitDialog(transaction: Transaction) {
      this.splitTargetTransaction = transaction;
    },
    closeSplitDialog() {
      this.splitTargetTransaction = null;
    },
    /** Keep the open drawer in sync after category/split writes. */
    patchTransaction(transactionId: string, patch: Partial<Transaction>) {
      if (this.selectedTransaction?.id === transactionId) {
        this.selectedTransaction = { ...this.selectedTransaction, ...patch };
      }
      // Intentionally do not patch splitTargetTransaction: mutating it while the
      // split dialog is open retriggers its watch and wipes in-progress lines.
    },
  },
});
